import React, { memo, useEffect, useState } from 'react';
import { Form, Checkbox, Radio } from 'tea-component';
import TeaFormItem from '@gp/components/TeaFormItem';
import { FILE_TYPES_MAP } from '@gp/constants/const';
import { DEFAULT_INFO_MAP, MILESTONE_TYPE_MAP_NEW} from './constants';
import './index.scss';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  currentSegment: ScheduleSegmentTypes;
  onChange: ((payload: ResultType) => void) | null;
}
interface ResultType {
  infoPoint: string[] | undefined;
  milestoneType: string | undefined;
  fileType: '1' | '2' | (string & {}) | undefined; // 1: CSV 2: EXCEL
}

const DEFAULT_PROPS: Props = {
  className: '',
  style: {},
  currentSegment: '',
  onChange: null,
};

function index(props: Props) {
  const { className, style, currentSegment, onChange } = props;

  // 暂存选择的结果
  const [result, setResult] = useState<ResultType>({
    infoPoint: undefined,
    milestoneType: undefined,
    fileType: undefined,
  });
  const [infoPoint, setInfoPoint] = useState<string[] | undefined>(undefined);
  const [milestoneType, setMilestoneType] = useState<string | undefined>(undefined);
  const [fileType, setFileType] = useState<string | undefined>(undefined);

  // 默认选择处理
  useEffect(() => {
    const defaultInfoPoint = DEFAULT_INFO_MAP?.map((t) => t?.value);
    const defaultMilestoneType = currentSegment || MILESTONE_TYPE_MAP_NEW.ALL_MILESTONE;
    const defaultFileType = FILE_TYPES_MAP.CSV;
    setInfoPoint(defaultInfoPoint);
    setMilestoneType(defaultMilestoneType);
    setFileType(defaultFileType);
    const newResult: ResultType = {
      infoPoint: defaultInfoPoint,
      milestoneType: defaultMilestoneType,
      fileType: defaultFileType,
    };
    onChange?.(newResult);
    setResult(newResult);
  }, [currentSegment]);

  return (
    <div
      className={`dbg-dashboard-schedule-calendar-download-modal-container  ${className}`}
      style={style}
    >
      <Form className="teaui-form-alignment">
        {/* Default Info */}
        <TeaFormItem labelName="Default Info">
          <Checkbox.Group
            value={infoPoint || []}
            onChange={(value) => {
              setInfoPoint(value);
              const newResult = {
                ...result,
                infoPoint: value,
              };
              onChange?.(newResult);
              setResult(newResult);
            }}
          >
            {DEFAULT_INFO_MAP?.map((t: { value: string; text: string }) => {
              return (
                <Checkbox key={t?.value} name={t?.value}>
                  {t?.text}
                </Checkbox>
              );
            })}
          </Checkbox.Group>
        </TeaFormItem>
        {/* Milestone */}
        <TeaFormItem labelName="Milestone">
          <Radio.Group
            className="dbg-common-radio-group"
            value={milestoneType || ''}
            onChange={(value) => {
              setMilestoneType(value);
              const newResult = {
                ...result,
                milestoneType: value,
              };
              onChange?.(newResult);
              setResult(newResult);
            }}
          >
            <Radio className="dbg-common-radio" name={MILESTONE_TYPE_MAP_NEW.ALL_MILESTONE}>
              All Milestone
            </Radio>
            <Radio
              className="dbg-common-radio"
              name={MILESTONE_TYPE_MAP_NEW.GR_MILESTONE}
            >
              GR Milestone
            </Radio>
            <Radio
              className="dbg-common-radio"
              name={MILESTONE_TYPE_MAP_NEW.CHECKIN_MILESTONE}
            >
              Check in Milestone
            </Radio>
            <Radio
              className="dbg-common-radio"
              name={MILESTONE_TYPE_MAP_NEW.LAUNCH_MILESTONE}
            >
              Launch Milestone
            </Radio>
            <Radio
              className="dbg-common-radio"
              name={MILESTONE_TYPE_MAP_NEW.TEST_MILESTONE}
            >
              Test Milestone
            </Radio>
            <Radio
              className="dbg-common-radio"
              name={MILESTONE_TYPE_MAP_NEW.OTHERS_MILESTONE}
            >
              Others Milestone
            </Radio>
          </Radio.Group>
        </TeaFormItem>
        {/* File Format */}
        <TeaFormItem labelName="File Format">
          <Radio.Group
            className="dbg-dashboard-schedule-calendar-download-modal-file-format-radio-group dbg-common-radio-group"
            value={fileType || ''}
            onChange={(value) => {
              setFileType(value);
              const newResult = {
                ...result,
                fileType: value,
              };
              onChange?.(newResult);
              setResult(newResult);
            }}
          >
            <Radio className="dbg-common-radio" name={FILE_TYPES_MAP.EXCEL}>
              Excel
            </Radio>
            <Radio className="dbg-common-radio" name={FILE_TYPES_MAP.CSV}>
              CSV
            </Radio>
          </Radio.Group>
        </TeaFormItem>
      </Form>
    </div>
  );
}

index.defaultProps = DEFAULT_PROPS;

export default memo(index);
